import { useSyncExternalStore } from "react";

const RESYNC_INTERVAL_MS = 1000 * 60;

let offsetMs = 0;
let started = false;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

const sync = async () => {
  const requestedAt = Date.now();
  const response = await fetch(`${import.meta.env.VITE_BASE_URL}/api/public/server_time`).catch(() => null);
  const receivedAt = Date.now();
  if (!response || !response.ok) return;

  const payload: { data?: { server_time_ms?: number } } | null = await response.json().catch(() => null);
  const serverTimeMs = Number(payload?.data?.server_time_ms);
  if (!Number.isFinite(serverTimeMs)) return;

  const roundTrip = receivedAt - requestedAt;
  const next = Math.round(serverTimeMs + roundTrip / 2 - receivedAt);
  if (next === offsetMs) return;

  offsetMs = next;
  emit();
};

const ensureStarted = () => {
  if (started) return;
  started = true;

  sync();
  setInterval(sync, RESYNC_INTERVAL_MS);
  window.addEventListener("focus", sync);
  window.addEventListener("online", sync);
};

const subscribe = (listener: () => void) => {
  ensureStarted();
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const useServerTimeOffset = (): number =>
  useSyncExternalStore(subscribe, () => offsetMs, () => 0);

export const useServerNow = (): number => Date.now() + useServerTimeOffset();
